document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.qalyon-mobile-swipe');
  if (!sliders.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  sliders.forEach((slider) => {
    let isDown = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let startIndex = 0;

    let dragged = false;
    let suppressClickUntil = 0;

    const DRAG_START = 12; // iOS sweet spot: 10–14
    const clampSwipe = (v) => v; // placeholder (damit Struktur clean bleibt)

    const getItems = () => Array.from(slider.querySelectorAll('.qalyon-mobile-swipe__item'));
    const getStops = () => getItems().map((el) => el.offsetLeft);

    const nearestIndex = (stops, x) => {
      let best = 0;
      let bestDist = Infinity;
      for (let i = 0; i < stops.length; i++) {
        const d = Math.abs(stops[i] - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    };

    const goTo = (stops, idx) => {
      if (!stops.length) return;
      slider.scrollTo({ left: stops[idx], behavior: 'auto' });
    };

    // Blocke nur Ghost-click direkt nach echtem Swipe
    slider.addEventListener('click', (ev) => {
      if (Date.now() < suppressClickUntil) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    }, true);

    slider.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' && e.pointerType !== 'touch') return;

      const stops = getStops();
      if (!stops.length) return;

      isDown = true;
      dragged = false;

      startX = e.clientX;
      startY = e.clientY;
      startScrollLeft = slider.scrollLeft;
      startIndex = nearestIndex(stops, startScrollLeft);

      slider.style.cursor = 'grabbing';
      slider.setPointerCapture(e.pointerId);
    });

    slider.addEventListener('pointermove', (e) => {
      if (!isDown) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      // Nur als Drag zählen, wenn wirklich horizontal + über Threshold
      if (!dragged && Math.abs(dx) > DRAG_START && Math.abs(dx) > Math.abs(dy)) {
        dragged = true;
      }

      // WICHTIG: nur wenn wirklich dragged -> scrollen + preventDefault
      if (dragged) {
        slider.scrollLeft = startScrollLeft - dx;
        e.preventDefault();
      }
    }, { passive: false });

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      slider.style.cursor = 'grab';

      const items = getItems();
      const stops = items.map((el) => el.offsetLeft);
      if (!stops.length) return;

      const delta = slider.scrollLeft - startScrollLeft;

      // PESO-like: pro Swipe nur 1 Schritt
      const thresholdPx = Math.max(40, slider.clientWidth * 0.08);
      let target = startIndex;

      const didSwipe = dragged && Math.abs(delta) > thresholdPx;

      if (didSwipe) {
        if (delta > thresholdPx) target = startIndex + 1;
        if (delta < -thresholdPx) target = startIndex - 1;

        target = clamp(target, startIndex - 1, startIndex + 1);
        target = clamp(target, 0, stops.length - 1);

        goTo(stops, target);

        // Ghost-click nur kurz nach echtem Swipe blocken
        suppressClickUntil = Date.now() + 250;
      } else {
        // Kein echter Swipe -> snap zurück auf current (optisch ruhig)
        goTo(stops, startIndex);
        suppressClickUntil = 0;
      }

      dragged = false;
    };

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener('mouseleave', endDrag);
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.qalyon-pdp-swipe');
  if (!sliders.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  sliders.forEach((slider) => {
    let isDown = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let startIndex = 0;

    let dragged = false;
    let suppressClickUntil = 0;

    const DRAG_START = 12; // iOS sweet spot

    const getItems = () => Array.from(slider.querySelectorAll('.product-gallery__media'));
    const getStops = () => getItems().map((el) => el.offsetLeft);

    const nearestIndex = (stops, x) => {
      let best = 0;
      let bestDist = Infinity;
      for (let i = 0; i < stops.length; i++) {
        const d = Math.abs(stops[i] - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    };

    const goTo = (stops, idx) => {
      if (!stops.length) return;
      slider.scrollTo({ left: stops[idx], behavior: 'auto' });
    };

    slider.addEventListener('click', (ev) => {
      if (Date.now() < suppressClickUntil) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    }, true);

    slider.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' && e.pointerType !== 'touch') return;

      const stops = getStops();
      if (!stops.length) return;

      isDown = true;
      dragged = false;

      startX = e.clientX;
      startY = e.clientY;
      startScrollLeft = slider.scrollLeft;
      startIndex = nearestIndex(stops, startScrollLeft);

      slider.style.cursor = 'grabbing';
      slider.setPointerCapture(e.pointerId);
    });

    slider.addEventListener('pointermove', (e) => {
      if (!isDown) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (!dragged && Math.abs(dx) > DRAG_START && Math.abs(dx) > Math.abs(dy)) {
        dragged = true;
      }

      if (dragged) {
        slider.scrollLeft = startScrollLeft - dx;
        e.preventDefault();
      }
    }, { passive: false });

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      slider.style.cursor = 'grab';

      const stops = getStops();
      if (!stops.length) return;

      const delta = slider.scrollLeft - startScrollLeft;

      const thresholdPx = Math.max(40, slider.clientWidth * 0.08);
      let target = startIndex;

      const didSwipe = dragged && Math.abs(delta) > thresholdPx;

      if (didSwipe) {
        if (delta > thresholdPx) target = startIndex + 1;
        if (delta < -thresholdPx) target = startIndex - 1;

        target = clamp(target, startIndex - 1, startIndex + 1);
        target = clamp(target, 0, stops.length - 1);

        goTo(stops, target);
        suppressClickUntil = Date.now() + 250;
      } else {
        goTo(stops, startIndex);
        suppressClickUntil = 0;
      }

      dragged = false;
    };

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener('mouseleave', endDrag);
  });
});